import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SubscriptionCategoryDetails from '@subscriptions/components/details/subscription-category-details/subscription-category-details.vue';

@Component({
  name: 'bpc-profile-subscription-category-details',
  components: {
    'bpc-subscription-category-details': SubscriptionCategoryDetails,
  },
})
export default class ProfileSubscriptionCategoryDetails extends Vue {
  @Prop({ type: [String, Number] }) readonly subscriptionCategoryId: string | number;
  @Prop({ type: [String, Number] }) readonly postId: string | number;
}
